import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { createPortal } from 'react-dom';

import styles from './NotificationBox.module.scss';

const NotificationBox = ({
  portalId,
  message = '',
  action = () => { },
  actionText = '',
}) => {
  const [mounted, setMounted] = useState(false);
  const portalTarget = document.getElementById(portalId);

  useEffect(() => {
    setTimeout(() => {
      setMounted(true);
    }, 0);
  }, []);

  const mainClass = classNames({
    [styles.main]: true,
    [styles['main--mounted']]: mounted,
  });

  const content = (
    <div className={mainClass}>
      <span className={styles.message}>
        {message}
      </span>
      <button onClick={action}>
        {actionText}
      </button>
    </div>
  );

  if (!portalTarget) {
    return null;
  }

  return (
    createPortal(
      content,
      portalTarget
    )
  );
};

export default NotificationBox;
